import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from './Icon';
import styled from 'styled-components';

const StyledButton = styled.button`
  background: ${
    props => props.props.bg ? props.props.bg
    : props => props.props.transparent && props.theme ? props.theme.transparent
    : props => props.props.blueDark && props.theme ? props.theme.blueDark
    : props => props.props.blueBright && props.theme ? props.theme.blueBright
    : props => props.props.greenDark && props.theme ? props.theme.greenDark
    : props => props.props.greenBright && props.theme ? props.theme.greenBright
    : props => props.props.orange && props.theme ? props.theme.orange
    : props => props.props.red && props.theme ? props.theme.red
    : props => props.props.blueDarkHalf && props.theme ? props.theme.blueDarkHalf
    : props => props.props.blueBrightHalf && props.theme ? props.theme.blueBrightHalf
    : props => props.props.greenDarkHalf && props.theme ? props.theme.greenDarkHalf
    : props => props.props.greenBrightHalf && props.theme ? props.theme.greenBrightHalf
    : props => props.props.orangeHalf && props.theme ? props.theme.orangeHalf
    : props => props.props.redHalf && props.theme ? props.theme.redHalf
    : props => props.props.dark && props.theme ? props.theme.dark : props.props.dark ? "#333"
    : props => props.props.bright && props.theme ? props.theme.bright : props.props.bright ? "#ccc"
    : props => props.props.white && props.theme ? props.theme.white : props.props.white ? "#fff"
    : props => props.theme ? props.theme.black : "#000"
  };
  color: ${
    props => props.props.color ? props.props.color
    : props => props.props.dark && props.theme ? props.theme.bright : props.props.bright ? "#ccc"
    : props => (props.props.bright || props.props.white) && props.theme ? props.theme.dark : props.props.dark ? "#333"
    : props.theme ? props.theme.white : "#fff"
  };
  height: ${
    props => props.props.fit ? '100%' : props.props.small ? "16px" : props.props.medium ? "32px"  : props.props.big ? "48px" : 'auto'
  };
  width: ${
    props => props.props.fit ? '100%' : props.props.small && props.props.small ? "16px" : 'auto'
  };
  opacity: ${
    props => props.props.disabled ? .3 : 1
  };
  font-size: .8em;
  line-height: 1;
  cursor: ${
    props => props.props.disabled ? 'default' : 'pointer'
  };
  pointer-events: ${
    props => props.props.disabled ? 'none' : 'all'
  };
  cursor: ${
    props => props.props.disabled ? 'default' : 'pointer'
  };
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  text-decoration: none;
  border: ${props => props.props.border || "none"};
  border-radius: ${
    props => props.props.borderRadius ? props.props.borderRadius
    : props => props.props.round && props.theme ? props.theme.round : props.props.round ? "100%"
    : props => props.props.rounded && props.theme ? props.theme.rounded : props.props.rounded ? "24px"
    : "0"
  };

  & > i,
  & > span:only-child {
    margin: 0 1em;
  }

  & svg,
  & svg g {
    stroke: ${
      props => props.props.color ? props.props.color
      : props => props.props.stroke ? props.props.stroke
      : props => props.props.dark && props.theme ? props.theme.bright : props.props.bright ? "#ccc"
      : props => (props.props.bright || props.props.white) && props.theme ? props.theme.dark : props.props.dark ? "#333"
      : props.theme ? props.theme.white : "#fff"
    };
    fill: ${
      props => props.props.fill || "none"
    };
  }

  @media (min-width: 1024px) {
    & > span:only-child {
      margin: 0 1em;
    }
  }
`;

export default function Button (props) {
  const {label, icon, icon2, href, target, rel, onClick, className} = props;
  const classes = classnames("btn", className);
  return (
    <StyledButton
      as={href && !!!onClick ? "a" : null}
      props={props} 
      href={href}
      target={href ? target : null}
      rel={href ? rel : null}
      onClick={onClick}
      className={classes}
    >
      {icon && <Icon name={icon}/>}
      {label && <span>{label}</span>}
      {icon2 && <Icon name={icon2}/>}
    </StyledButton>)
}

Button.defaultProps = {
  target: "_self",
  rel: "noreferrer"
}

Button.propTypes = {
  tiny: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  big: PropTypes.bool,
  huge: PropTypes.bool,
  fit: PropTypes.bool,
  round: PropTypes.bool,
  rounded: PropTypes.bool,
  icon: PropTypes.string,
  textAlign: PropTypes.string,
  iconAlign: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
  bg: PropTypes.string,
  dark: PropTypes.bool,
  bright: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.any
 };
